export interface Character {
  id: string;
  name: string;
  actor: string;
  role: string;
  description: string;
  avatar: string;
  traits: string[];
  appearsIn: string[];
}

export const characters: Character[] = [
  {
    id: "kevin",
    name: "凯文·阿什福德",
    actor: "伊桑·布莱克",
    role: "长子 / 归来者",
    description:
      "三年前离开家族，如今带着一桩不愿提起的旧事回到老宅。冷静、克制，习惯把所有情绪压到最后一秒爆发，是全剧的视角核心。",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20dark%20portrait%20of%20a%20brooding%20man%20in%20shadow%20with%20deep%20crimson%20rim%20light%2C%20film%20noir%20mood%2C%20dramatic%20amber%20accent%2C%20moody%20background%2C%20high%20detail&width=400&height=400&seq=ats2-char-01&orientation=squarish",
    traits: ["克制", "复杂", "背负秘密"],
    appearsIn: ["ep-01", "ep-03", "ep-06", "ep-08", "ep-09", "ep-10"],
  },
  {
    id: "margaret",
    name: "玛格丽特·阿什福德",
    actor: "玛戈·雷诺兹",
    role: "母亲 / 家族掌舵人",
    description:
      "阿什福德家族的绝对核心。她用体面与礼仪维系着整个家的秩序，也用同样的方式掩盖了最深的那道裂痕。",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20dark%20portrait%20of%20an%20elegant%20older%20woman%20in%20shadow%20with%20amber%20light%2C%20deep%20crimson%20accents%2C%20film%20noir%20mood%2C%20moody%20background%2C%20high%20detail&width=400&height=400&seq=ats2-char-02&orientation=squarish",
    traits: ["强势", "体面", "深藏不露"],
    appearsIn: ["ep-01", "ep-02", "ep-04", "ep-05", "ep-07", "ep-09", "ep-10"],
  },
  {
    id: "daniel",
    name: "丹尼尔·阿什福德",
    actor: "卢卡斯·凯恩",
    role: "次子 / 守家者",
    description:
      "一直留在老宅的人。他看似顺从，实则是全剧最痛苦的角色——既要维护母亲，又无法对哥哥视而不见。",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20dark%20portrait%20of%20a%20tense%20young%20man%20in%20shadow%20with%20dim%20amber%20light%2C%20deep%20crimson%20accents%2C%20film%20noir%20mood%2C%20moody%20background%2C%20high%20detail&width=400&height=400&seq=ats2-char-03&orientation=squarish",
    traits: ["隐忍", "两难", "忠诚"],
    appearsIn: ["ep-01", "ep-02", "ep-04", "ep-05", "ep-07", "ep-09"],
  },
  {
    id: "lina",
    name: "莉娜·阿什福德",
    actor: "索菲亚·维拉",
    role: "小女儿 / 反叛者",
    description:
      "被家族当作「不懂事的那一个」。她退学的真相被误解多年，直到她终于决定为自己发声。",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20dark%20portrait%20of%20a%20defiant%20young%20woman%20in%20shadow%20with%20amber%20light%2C%20deep%20crimson%20accents%2C%20film%20noir%20mood%2C%20moody%20background%2C%20high%20detail&width=400&height=400&seq=ats2-char-04&orientation=squarish",
    traits: ["直率", "清醒", "受伤"],
    appearsIn: ["ep-02", "ep-04", "ep-07", "ep-08", "ep-09", "ep-10"],
  },
  {
    id: "eric",
    name: "埃里克·索耶",
    actor: "凯拉·莫里斯",
    role: "旧友 / 第 14 街",
    description:
      "凯文少年时代最好的朋友，也是那场事故里被留下的人。十年后再度出现，他带来的不只是回忆。",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20dark%20portrait%20of%20a%20weathered%20man%20in%20shadow%20with%20crimson%20and%20amber%20light%2C%20film%20noir%20mood%2C%20moody%20background%2C%20high%20detail&width=400&height=400&seq=ats2-char-05&orientation=squarish",
    traits: ["直白", "危险", "重情"],
    appearsIn: ["ep-03", "ep-06", "ep-08"],
  },
  {
    id: "nathan",
    name: "内森·福特",
    actor: "内森·福特",
    role: "家族律师 / 旁观者",
    description:
      "阿什福德家多年的法律顾问，掌握最多秘密的人。他的每一次出现，都意味着某件被藏起的事即将浮出水面。",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20dark%20portrait%20of%20a%20serious%20man%20holding%20documents%20in%20shadow%20with%20amber%20light%2C%20deep%20crimson%20accents%2C%20film%20noir%20mood%2C%20moody%20background%2C%20high%20detail&width=400&height=400&seq=ats2-char-06&orientation=squarish",
    traits: ["冷静", "知情者", "立场成谜"],
    appearsIn: ["ep-02", "ep-05", "ep-06", "ep-09"],
  },
  {
    id: "father",
    name: "亚瑟·阿什福德",
    actor: "（回忆登场）",
    role: "已故父亲",
    description:
      "整部剧的起点。他的那封未寄出的信，是所有人沉默的源头，也是全剧最大的悬念所在。",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20dark%20portrait%20of%20a%20distant%20older%20man%20in%20deep%20shadow%20with%20faint%20amber%20light%2C%20deep%20crimson%20accents%2C%20film%20noir%20mood%2C%20moody%20background%2C%20high%20detail&width=400&height=400&seq=ats2-char-07&orientation=squarish",
    traits: ["缺席", "源头", "神秘"],
    appearsIn: ["ep-01", "ep-03", "ep-10"],
  },
  {
    id: "claire",
    name: "克莱尔·贝内特",
    actor: "（特邀出演）",
    role: "记者 / 外来的提问者",
    description:
      "从外部进入这个家庭的观察者。她用记者的本能，问出了所有家人都不敢问出口的问题。",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20dark%20portrait%20of%20a%20curious%20woman%20with%20a%20notebook%20in%20shadow%20with%20amber%20light%2C%20deep%20crimson%20accents%2C%20film%20noir%20mood%2C%20moody%20background%2C%20high%20detail&width=400&height=400&seq=ats2-char-08&orientation=squarish",
    traits: ["敏锐", "中立", "追问"],
    appearsIn: ["ep-02", "ep-06", "ep-08"],
  },
];

export const characterByName = (name: string): Character | undefined =>
  characters.find((character) => character.name === name);